<template>
  <div>
    <img
      src="@/assets/tarjeta_servicios_declarar_siniestro.jpg"
      style="width: 100%"
    />

    <p class="tituloTarjeta">ATENCIÓN SINIESTROS</p>
    <p>
      Déjanos tus datos y te llamamos en horario de Lunes a Viernes de 9:00 a
      20:00.
    </p>

    <p>
      Si lo prefieres puedes llamar al
      <span class="noSeparar">91 594 88 38</span> “Centro de Atención al
      Cliente”.
    </p>
    <p><br /></p>
    <p class="container-flex">
      <a href="tel:+ 34 91 594 88 38">
        <button
          class="pure-button botonLlamar"
          title="Pulsa el botón para llamar a nuestro Centro de Atención al Cliente"
        >
          Llamar
        </button>
      </a>

      <button
        class="pure-button botonLlamar"
        title="Pulsa el botón para ponernos en contacto contigo"
        @click.prevent="confirmTel(true)"
      >
        Te llamamos
      </button>

      <TeLlamamosConfirmTel
        v-if="popUpConfirmTel"
        :telefono-inic="$store.state.portfolio.cliente.telefono"
        :asunto-inic="asunto()"
        @close="confirmTel(false)"
      />
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popUpConfirmTel: false,
    };
  },

  methods: {
    asunto() {
      return "S";
    },
    confirmTel(val) {
      this.popUpConfirmTel = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  text-align: center;
  border-radius: 0.5rem;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
